import { SizeProperty } from '@topcon/tuicl';
import {
  TeBadge,
  TeContainer,
  TeContainerSlim,
  TeDivider,
  TeIcon,
  TeText,
} from '@topcon/tuicl-react';
import { IconName } from '@topcon/tuicl/dist/components/icon/icon.utils';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  onClick: () => void;
  icon?: IconName;
  title: string;
  active: boolean;
  showActiveLabel?: boolean;
  disabled?: boolean;
  padding?: SizeProperty;
  titleTextSize?: SizeProperty;
  titleTextColor?: string;
  badgeLabel?: string;
}

const SelectableItem = ({
  onClick,
  icon,
  title,
  active,
  showActiveLabel,
  disabled,
  children,
  padding,
  badgeLabel,
  titleTextSize = 'm',
  titleTextColor = 'text.primary',
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  return (
    <Container
      grow
      column
      gap="s"
      disabled={disabled}
      borderColor={active ? 'border.brand.primary' : 'border.primary'}
      borderRadius={4}
      backgroundColor={active ? 'background.selected' : 'background.primary'}
      onClick={() => {
        if (disabled === true) return;
        onClick();
      }}
      padding={padding}
    >
      <TeContainerSlim fill alignItems="center" gap="xs">
        {icon && <TeIcon name={icon} />}
        <TeContainerSlim fill grow alignItems="center" justifyContent="space-between">
          <TeText weight={700} size={titleTextSize} color={titleTextColor}>
            {title}
          </TeText>
          {showActiveLabel && active && (
            <TeBadge
              text={badgeLabel || t('selected')}
              backgroundColor="background.brand.primary"
              borderRadius="l"
              size="s"
            />
          )}
        </TeContainerSlim>
      </TeContainerSlim>

      <TeDivider dividerColor="border.primary" />

      <TeContainerSlim column fill gap="xs">
        {children}
      </TeContainerSlim>
    </Container>
  );
};

const Container = styled(TeContainer)<{
  disabled?: boolean;
}>`
  opacity: ${(props) => (props.disabled === true ? 0.4 : 1)};
  cursor: ${(props) => (props.disabled === true ? 'not-allowed' : 'pointer')};
`;

export default SelectableItem;
